import { $Q } from "./query-selector"
import { resetVideo } from "../components/video-frame";

/**
 *
 * @param {String} id - ID from node manipulate
 * @param {Boolean} active - If modal active
 * @param {HTMLElement} node - Node to manipulate
 */
 const overlayActions = (id, active, node) => {
  const idOverlay = `overlay--${id}`;
  const parent = node.parentNode;

  if (!active) {
    // eslint-disable-next-line no-undef
    const overlay = document.createElement("div");

    overlay.setAttribute("id", idOverlay);
    overlay.classList.add("overlay");
    document.body.style.overflow = 'hidden';

    parent.insertBefore(overlay, node);
    // eslint-disable-next-line no-use-before-define
    toggleDataActive(`#${idOverlay}`, `#${id}`, { overlay: true });
  } else {
    parent.removeChild($Q(`#${idOverlay}`));
    document.body.style.overflow = 'initial';
  }
}

/**
 * To validate state in dataset node
 */
export const isActive = ({ active }) => active === "true";

/**
* Data Toggle
*
* @param {HTMLElement} node - Node to manipulate
* @param {Boolean} overlay - if used to a overlay
*/
export function dataToggle(node, overlay) {

  const { dataset, id } = node;
  const active = isActive(dataset);

  if (active) {
    node.setAttribute('data-active', 'false')
  } else {
    node.setAttribute('data-active', 'true')
  }

  if (overlay) {
    overlayActions(id, active, node);

    if (node.classList.contains("video__modal")) {
      resetVideo(node);
    }
  }

  return active;
}
/**
 * Data Active toggle
 *
 * @param {String} control - ID button control
 * @param {String} node - ID modal
 * @param {Object} config - Object with overlay, closeSelector
 */
 export const toggleDataActive = (control, node, config = {}) => {
  const { overlay, closeSelector, video, callback } = config;
  const target = $Q(node);

  $Q(control).addEventListener("click", () => {
    dataToggle(target, overlay, video);
    if (callback) callback();
  });

  if (closeSelector) {
    $Q(closeSelector, target).addEventListener(
      "click",
      () => {
        dataToggle(target, overlay);
        if ($Q(closeSelector).classList.contains("video__close")) {
          resetVideo(target);
        }
      },
    )
  }
}
